(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9163],{

/***/ 7885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumbs_Breadcrumbs; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(41451);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/node_modules/react-is/index.js
var react_is = __webpack_require__(65122);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(40922);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(59693);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js + 1 modules
var createSvgIcon = __webpack_require__(594);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/MoreHoriz.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var MoreHoriz = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz'));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(41810);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/BreadcrumbCollapsed.js









var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      backgroundColor: theme.palette.grey[100],
      color: theme.palette.grey[700],
      borderRadius: 2,
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: theme.palette.grey[200]
      },
      '&:active': {
        boxShadow: theme.shadows[0],
        backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.grey[200], 0.12)
      }
    },
    icon: {
      width: 24,
      height: 16
    }
  };
};
/**
 * @ignore - internal component.
 */


function BreadcrumbCollapsed(props) {
  var classes = props.classes,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["classes"]);

  return /*#__PURE__*/react.createElement(ButtonBase/* default */.Z, (0,esm_extends/* default */.Z)({
    component: "li",
    className: classes.root,
    focusRipple: true
  }, other), /*#__PURE__*/react.createElement(MoreHoriz, {
    className: classes.icon
  }));
}

 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_BreadcrumbCollapsed = ((0,withStyles/* default */.Z)(styles, {
  name: 'PrivateBreadcrumbCollapsed'
})(BreadcrumbCollapsed));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js










var Breadcrumbs_styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the ol element. */
  ol: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  },

  /* Styles applied to the li element. */
  li: {},

  /* Styles applied to the separator element. */
  separator: {
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
  }
};

function insertSeparators(items, className, separator) {
  return items.reduce(function (acc, current, index) {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/react.createElement("li", {
        "aria-hidden": true,
        key: "separator-".concat(index),
        className: className
      }, separator));
    } else {
      acc.push(current);
    }

    return acc;
  }, []);
}

var Breadcrumbs = /*#__PURE__*/react.forwardRef(function Breadcrumbs(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'nav' : _props$component,
      _props$expandText = props.expandText,
      expandText = _props$expandText === void 0 ? 'Show path' : _props$expandText,
      _props$itemsAfterColl = props.itemsAfterCollapse,
      itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
      _props$itemsBeforeCol = props.itemsBeforeCollapse,
      itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
      _props$maxItems = props.maxItems,
      maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems,
      _props$separator = props.separator,
      separator = _props$separator === void 0 ? '/' : _props$separator,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["children", "classes", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]);

  var _React$useState = react.useState(false),
      expanded = _React$useState[0],
      setExpanded = _React$useState[1];

  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter(allItems) {
    var handleClickExpand = function handleClickExpand(event) {
      setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.

      var focusable = event.currentTarget.parentNode.querySelector('a[href],button,[tabindex]');

      if (focusable) {
        focusable.focus();
      }
    }; // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem


    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (false) {}

      return allItems;
    }

    return [].concat((0,toConsumableArray/* default */.Z)(allItems.slice(0, itemsBeforeCollapse)), [/*#__PURE__*/react.createElement(Breadcrumbs_BreadcrumbCollapsed, {
      "aria-label": expandText,
      key: "ellipsis",
      onClick: handleClickExpand
    })], (0,toConsumableArray/* default */.Z)(allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)));
  };

  var allItems = react.Children.toArray(children).filter(function (child) {
    if (false) {}

    return /*#__PURE__*/react.isValidElement(child);
  }).map(function (child, index) {
    return /*#__PURE__*/react.createElement("li", {
      className: classes.li,
      key: "child-".concat(index)
    }, child);
  });
  return /*#__PURE__*/react.createElement(Typography/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: ref,
    component: Component,
    color: "textSecondary",
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, other), /*#__PURE__*/react.createElement("ol", {
    className: classes.ol
  }, insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
});
 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_Breadcrumbs = ((0,withStyles/* default */.Z)(Breadcrumbs_styles, {
  name: 'MuiBreadcrumbs'
})(Breadcrumbs));

/***/ }),

/***/ 40341:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
__webpack_unused_export__=y;


/***/ }),

/***/ 65122:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  /* unused reexport */ __webpack_require__(40341);
} else {}


/***/ }),

/***/ 71007:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warranty",
      function () {
        return __webpack_require__(90233);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js + 2 modules
var Breadcrumbs = __webpack_require__(7885);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/constants.ts
var constants = __webpack_require__(45053);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(90387);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./reusable/icons/BreadCrumbsIcon.tsx

var SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "4",
        height: "8",
        viewBox: "0 0 4 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.5 7L0.5 4L3.5 1",
            stroke: "#D5D5D5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var BreadCrumbsIcon = (SvgComponent);

;// CONCATENATED MODULE: ./common/BreadCrumbsData.tsx
var BreadCrumbsData = {
    PrivacyPolicy: {
        links: [
            {
                title: "מדיניות הפרטיות",
                link: "/privacy-policy"
            }, 
        ]
    },
    TermsOfUse: {
        links: [
            {
                title: "תנאי שימוש",
                link: "/terms-of-use"
            }, 
        ]
    },
    Accessibility: {
        links: [
            {
                title: "הצהרת נגישות",
                link: "/accessibility"
            }, 
        ]
    },
    SiteMap: {
        links: [
            {
                title: "מפת אתר",
                link: "/sitemap"
            }
        ]
    },
    Recall: {
        links: [
            {
                title: "קריאות חוזרות",
                link: "/recall"
            }, 
        ]
    },
    Warranty: {
        links: [
            {
                title: "כתב אחריות",
                link: "/warranty"
            }, 
        ]
    },
    ServiceInstructions: {
        links: [
            {
                title: "הוראות שירות",
                link: "/service-instructions"
            }, 
        ]
    },
    WarrantyExtension: {
        links: [
            {
                title: "בדיקת תכולת הארכת אחריות",
                link: "/warranty-extension"
            }
        ]
    },
    SparePriceList: {
        links: [
            {
                title: "מחירון מוצרי תעבורה",
                link: "/spare-price-list"
            }, 
        ]
    },
    ColorCode: {
        links: [
            {
                title: "קוד צבע",
                link: "/color-code"
            }, 
        ]
    },
    Hamesayat: {
        links: [
            {
                title: "המסייעת",
                link: "/hamesayat"
            }, 
        ]
    },
    VideoTutorials: {
        links: [
            {
                title: "סרטוני הדרכה ותפעול",
                link: "/video-tutorials"
            }, 
        ]
    },
    ServicesCenters: {
        links: [
            {
                title: "מרכזי שירות",
                link: "/services-centers"
            }, 
        ]
    },
    ShowRooms: {
        links: [
            {
                title: "אולמות תצוגה",
                link: "/show-rooms"
            }, 
        ]
    },
    CarList: {
        links: [
            {
                title: "מחירון מכוניות",
                link: "/car-list"
            }, 
        ]
    },
    Insurance: {
        links: [
            {
                title: "ביטוח",
                link: "/insurance"
            }, 
        ]
    },
    CarFleets: {
        links: [
            {
                title: "ציי רכב",
                link: "/car-fleets"
            }, 
        ]
    },
    ContactUs: {
        links: [
            {
                title: "צרו קשר",
                link: "/contact-us"
            }, 
        ]
    },
    ServicePlans: {
        links: [
            {
                title: "תוכנית טיפול",
                link: "/service-plans"
            }, 
        ]
    }
};


// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/bit/utils/slugify.ts
var slugify = __webpack_require__(38730);
;// CONCATENATED MODULE: ./common/BreadCrumbs.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n\n  ",
        " {\n  }\n  ",
        " {\n    position: absolute;\n\n    ",
        ";\n    ",
        ";\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  max-width: 1400px;\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n    display: flex;\n    justify-content: flex-start;\n    padding-right: 20px;\n  }\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n  }\n  svg {\n    margin-top: 2px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 10px;\n  font-weight: 300;\n  letter-spacing: normal;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var SINGLE_SERVICE = "singleService";
var CONFIGURATOR = "configurator";
var StyledInnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledInnerWrapper",
    componentId: "sc-e82e91a2-0"
})(_templateObject(), function(p) {
    return p.$page === SINGLE_SERVICE && "top: -20px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 25px";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "right: 50px;";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "top: -10px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 0px";
});
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledWrapper",
    componentId: "sc-e82e91a2-1"
})(_templateObject1(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$page) !== CONFIGURATOR && "width: 100%;";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$page === CONFIGURATOR && "margin-top: -50px";
}, function(p) {
    return p.$page === CONFIGURATOR && (p === null || p === void 0 ? void 0 : p.$pathname) !== constants/* STEPS_EN.summary */.Ws.summary && "margin-right: 50px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "padding-right: 15px;";
}, function(p) {
    return p.$pathname === constants/* STEPS_EN.color */.Ws.color && "padding-right: 16px";
});
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    displayName: "BreadCrumbs__StyledLink",
    componentId: "sc-e82e91a2-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.disable;
});
var BreadCrumbsWrapper = function(param) {
    var name = param.name, modelName = param.modelName, id = param.id, page = param.page, pathname = param.pathname;
    var router = (0,client_router.useRouter)();
    var carLinkUrl = function() {
        var carLink = "/model/[modelId]/[modelSlug]".replace("[modelId]", id.toString()).replace("[modelSlug]", (0,slugify/* default */.Z)(modelName));
        return carLink;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        $page: page,
        $pathname: pathname,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerWrapper, {
            $page: page,
            children: [
                BreadCrumbsData[name] && !modelName && !id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        BreadCrumbsData[name].links.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                color: "inherit",
                                href: item.link,
                                "aria-current": index === BreadCrumbsData[name].links.length - 1 && page !== SINGLE_SERVICE ? "page" : "step",
                                children: item.title
                            }, index);
                        }),
                        page === SINGLE_SERVICE && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: router.asPath,
                            "aria-current": "page",
                            children: router.query.serviceCenterSlug.toString().replace(/-/g, " ")
                        })
                    ]
                }),
                modelName && id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/models",
                            children: "לכל הדגמים"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: carLinkUrl(),
                            "aria-current": page !== CONFIGURATOR ? "page" : "step",
                            children: modelName
                        }),
                        page && page === CONFIGURATOR && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: router.asPath,
                            "aria-current": "page",
                            children: "התאמה אישית ורכישה"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var BreadCrumbs = (BreadCrumbsWrapper);


/***/ }),

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 97294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$L": function() { return /* binding */ StyledHeaderSubtitle; },
/* harmony export */   "$v": function() { return /* binding */ StyledTh; },
/* harmony export */   "EF": function() { return /* binding */ StyledLi; },
/* harmony export */   "Fg": function() { return /* binding */ StyledLink; },
/* harmony export */   "GI": function() { return /* binding */ StyledTd; },
/* harmony export */   "PW": function() { return /* binding */ StyledSmallText; },
/* harmony export */   "SG": function() { return /* binding */ StyledThead; },
/* harmony export */   "TK": function() { return /* binding */ StyledSubtitle; },
/* harmony export */   "ZN": function() { return /* binding */ StyledBody2; },
/* harmony export */   "aG": function() { return /* binding */ StyledTr; },
/* harmony export */   "eX": function() { return /* binding */ StyledH3; },
/* harmony export */   "hc": function() { return /* binding */ StyledUl; },
/* harmony export */   "k6": function() { return /* binding */ StyledTable; },
/* harmony export */   "vc": function() { return /* binding */ StyledBody; },
/* harmony export */   "x0": function() { return /* binding */ StyledHeaderH2; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22318);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        "px;\n  ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  margin-top: ",
        "px;\n  font-weight: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  ",
        ";\n  letter-spacing: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  margin-top: 40px;\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  color: ',
        ";\n  ",
        " {\n    max-width: 300px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0px;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n  &::marker {\n    font-size: 10px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: underline;\n  ",
        ";\n  color: ",
        ";\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  margin-top: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-collapse: collapse;\n  text-align: right;\n  margin-top: 10px;\n  ",
        " {\n    display: block;\n    width: ",
        ";\n    overflow: auto;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  ",
        " {\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: normal;\n  td:first-child {\n    font-size: 16px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  padding: 7px 7px;\n  font-size: 16px;\n  line-height: 1;\n  font-weight: normal;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 7px 5px;\n  border: 1px solid ",
        ";\n  font-size: 18px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}


var StyledHeaderH2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "BodyText__StyledHeaderH2",
    componentId: "sc-d1eb1ea9-0"
})(_templateObject(), function(p) {
    return p.$position && "text-align: ".concat(p.$position);
}, function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin);
}, function(p) {
    return p.$lineHeight && "line-height: ".concat(p.$lineHeight);
}, function(p) {
    return p.$fontSize ? "".concat(p.$fontSize, "px") : "24px";
}, function(p) {
    return p.$fontWeight ? p.$fontWeight : "400";
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledSubtitle",
    componentId: "sc-d1eb1ea9-1"
})(_templateObject1(), function(p) {
    return p.$margin;
}, function(p) {
    return p.$fontWeight ? p.$fontWeight : "bold";
});
var StyledHeaderSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledHeaderSubtitle",
    componentId: "sc-d1eb1ea9-2"
})(_templateObject2(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "20px";
}, function(p) {
    return p.$position && "text-align: ".concat(p.$position);
});
var StyledBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "BodyText__StyledBody",
    componentId: "sc-d1eb1ea9-3"
})(_templateObject3(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "10px";
}, function(p) {
    return p.$position && "text-align: ".concat(p.$position);
}, function(p) {
    return p.$fontSize ? "".concat(p.$fontSize, "px") : "18px";
});
var StyledH3 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledH3",
    componentId: "sc-d1eb1ea9-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledUl = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    displayName: "BodyText__StyledUl",
    componentId: "sc-d1eb1ea9-5"
})(_templateObject5(), function(p) {
    return p.$padding && "padding-right: ".concat(p.$padding, "px");
});
var StyledLi = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    displayName: "BodyText__StyledLi",
    componentId: "sc-d1eb1ea9-6"
})(_templateObject6(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "0px";
});
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    displayName: "BodyText__StyledLink",
    componentId: "sc-d1eb1ea9-7"
})(_templateObject7(), function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin, "px");
}, function(p) {
    return p.$color ? p.$color : p.theme.colors.mazdaRed;
}, function(p) {
    return p.$display && "display: ".concat(p.$display);
}, function(p) {
    return p.$fontSize && "font-size: ".concat(p.$fontSize, "px");
});
var StyledSmallText = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "BodyText__StyledSmallText",
    componentId: "sc-d1eb1ea9-8"
})(_templateObject8(), function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "10px";
}, function(p) {
    return p.$fontWeight && "font-weight: ".concat(p.$fontWeight);
});
var StyledBody2 = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "BodyText__StyledBody2",
    componentId: "sc-d1eb1ea9-9"
})(_templateObject9(), function(p) {
    return p.$fontSize && "font-size: ".concat(p.$fontSize, "px");
}, function(p) {
    return p.$margin && "margin-top: ".concat(p.$margin, "px");
});
var StyledTable = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    displayName: "BodyText__StyledTable",
    componentId: "sc-d1eb1ea9-10"
})(_templateObject10(), function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$width ? p.$width : "350px";
}, function(p) {
    return p.theme.breakpoints.down("xs");
}, function(p) {
    return p.$width ? p.$width : "90vw";
});
var StyledThead = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].thead.withConfig */ .ZP.thead.withConfig({
    displayName: "BodyText__StyledThead",
    componentId: "sc-d1eb1ea9-11"
})(_templateObject11());
var StyledTr = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].tr.withConfig */ .ZP.tr.withConfig({
    displayName: "BodyText__StyledTr",
    componentId: "sc-d1eb1ea9-12"
})(_templateObject12(), function(p) {
    return p.theme.colors.black;
});
var StyledTh = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].th.withConfig */ .ZP.th.withConfig({
    displayName: "BodyText__StyledTh",
    componentId: "sc-d1eb1ea9-13"
})(_templateObject13(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.theme.colors.darkGrey;
});
var StyledTd = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].td.withConfig */ .ZP.td.withConfig({
    displayName: "BodyText__StyledTd",
    componentId: "sc-d1eb1ea9-14"
})(_templateObject14(), function(p) {
    return p.theme.colors.darkGrey;
});


/***/ }),

/***/ 86040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ StyledHeaderH1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57402);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  ",
        " {\n    text-align: right;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: ",
        ";\n  margin-top: ",
        ";\n  word-break: ",
        ';\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 34px;\n  letter-spacing: 0.05em;\n  color: ',
        ";\n  ",
        " {\n    text-align: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  margin-top: 20px;\n  font-weight: 300;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  margin-top: 20px;\n  font-family: "OENaPro";\n  font-style: normal;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 27px;\n  color: ',
        ";\n  width: ",
        ";\n  margin: auto;\n  ",
        ";\n  ",
        " {\n    text-align: right;\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 0.5px;\n  background-color: ",
        ";\n  margin-top: 40px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var StyledCenterText = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CenterText__StyledCenterText",
    componentId: "sc-cd579a81-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledHeaderH1 = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "h1"
}).withConfig({
    displayName: "CenterText__StyledHeaderH1",
    componentId: "sc-cd579a81-1"
})(_templateObject1(), function(p) {
    return p.$margin ? "center" : "center";
}, function(p) {
    return p.$margin ? "".concat(p.$margin, "px") : "0";
}, function(p) {
    return p.$break && p.$break;
}, function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$align ? p.$align : "right";
});
var StyledHeaderSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "CenterText__StyledHeaderSubtitle",
    componentId: "sc-cd579a81-2"
})(_templateObject2());
var StyledBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "CenterText__StyledBody",
    componentId: "sc-cd579a81-3"
})(_templateObject3(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.$page === "color" ? "500px" : "985px";
}, function(p) {
    return p.$margin && "margin-top: 20px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledLine = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CenterText__StyledLine",
    componentId: "sc-cd579a81-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.darkGrey;
});
var StyledFooterText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "CenterText__StyledFooterText",
    componentId: "sc-cd579a81-5"
})(_templateObject5());
var CenterText = function(param) {
    var title = param.title, subtitle = param.subtitle, headerText = param.headerText, footerText = param.footerText, withBorder = param.withBorder, margin = param.margin, page = param.page;
    var isDesktop = (0,common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .useIsDesktop */ .Ce)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledCenterText, {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeaderH1, {
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHeaderSubtitle, {
                children: subtitle
            }),
            headerText.map(function(text) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBody, {
                    $margin: margin,
                    $page: page,
                    children: text
                }, text);
            }),
            footerText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledFooterText, {
                children: footerText
            }) : null,
            isDesktop && withBorder && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLine, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CenterText);


/***/ }),

/***/ 63358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13328);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n  height: 150px;\n  ",
        " {\n    height: 270px;\n    ",
        ";\n  }\n  img {\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ImageContainer__StyledImageContainer",
    componentId: "sc-4c5af28c-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$collapseOpen && "margin-top: 63px";
});
var ImageContainer = function(param) {
    var src = param.src;
    var collapseOpen = (0,store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)(function(state) {
        return state.collapseLayout;
    }).collapseOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImageContainer, {
        $collapseOpen: collapseOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            src: src,
            layout: "fill",
            priority: true,
            alt: "page-cover-img",
            role: "presentation",
            "aria-hidden": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageContainer);


/***/ }),

/***/ 90233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ warranty; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./common/BreadCrumbs.tsx + 2 modules
var BreadCrumbs = __webpack_require__(15738);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
// EXTERNAL MODULE: ./reusable/wrappers/ImageContainer.tsx
var ImageContainer = __webpack_require__(63358);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./reusable/wrappers/BodyText.tsx
var BodyText = __webpack_require__(97294);
;// CONCATENATED MODULE: ./components/pages/warranty/WarrantyBody.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  li {\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style-type: none;\n  padding: 0px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  margin-top: 10px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "WarrantyBody__StyledWrapper",
    componentId: "sc-48d982a5-0"
})(_templateObject());
var StyledHeaderSubtitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "subtitle1"
}).withConfig({
    displayName: "WarrantyBody__StyledHeaderSubtitle",
    componentId: "sc-48d982a5-1"
})(_templateObject1(), function(p) {
    return p.$margin && "".concat(p.$margin, "px");
});
var StyledUlText = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
    displayName: "WarrantyBody__StyledUlText",
    componentId: "sc-48d982a5-2"
})(_templateObject2());
var StyledLiText = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "WarrantyBody__StyledLiText",
    componentId: "sc-48d982a5-3"
})(_templateObject3());
var WarrantyBody = function() {
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                $position: "right",
                $margin: 40,
                children: "אחריות מוגבלת לרכב חדש"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "מה מציעה האחריות המוגבלת לרכב חדש חברת מאזדה מעניקה לבעלים של רכב חדש מתוצרת מאזדה, אחריות לכך שהרכב חופשי מפגמים שמקורם בחומר לקוי או בעבודה לקויה, בכפוף לתנאים שלהלן."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "חברת, MAZDA MOTOR CORPORATION באמצעות דלק מוטורס או מוסך שירות מורשה מטעמה, תבצע את כל התיקונים הדרושים לצורך תיקון פגם שמקורו בחומר או בייצור, תוך שימוש בחלקים חדשים או משוקמים, ללא חיוב בעל/י הרכב."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "1. ישימות האחריות"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "כתב האחריות מתייחס לרכב מתוצרת מאזדה שנרשם ומופעל בישראל. במהלך תקופת האחריות ניתן להעבירה לבעלים הבאים של הרכב."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "2. תקופת האחריות"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: 'כיסוי האחריות המוענק על-ידי חברת מאזדה (MAZDA MOTOR CORPORATION) במסגרת האחריות המוגבלת לרכב חדש, היא לתקופה של 24 חודשים ללא הגבלת מרחק נסיעה מצטבר, החל מן היום בו נמסר הרכב החדש לבעליו. בתום התקופה בת 24 חודשים הראשונים, באם הרכב טרם גמא 100,000 ק"מ, תימשך תקופת האחריות לתקופה בת 12 חודשים נוספים, עד לתום 36 חודשים ממועד מסירת הרכב החדש לבעליו או עד הגיע הרכב למרחק נסיעה מצטבר של 100,000 ק"מ ממועד מסירת הרכב החדש לבעליו (המוקדם מבניהם).'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "אחריות לקרר (גז הקירור) שבמערכת המיזוג"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "הקרר (גז הקירור) שבמערכת המיזוג מכוסה לתקופה של 12 החודשים הראשונים אלא אם הוחלף במערכת זו פריט המצריך מילוי גז נוסף במסגרת תיקון באחריות."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "מנגנון ההנעה של נגן קלטות ונגן מקוריים (CD) תקליטורים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "מנגנון ההנעה של נגן קלטות ונגן תקליטורים (CD) מכוסה לתקופה של 12 החודשים הראשונים ללא הגבלת מרחק נסיעה מצטבר."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "מצבר"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "המצבר המקורי מכוסה למשך 24 חודשים החל מן היום בו נרשם הרכב במשרד הרישוי רישום ראשוני, ללא הגבלת מרחק נסיעה מצטבר."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "האחריות לרכב לא תחול על פגם שנוצר עקב אחד או יותר מאלה:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUlText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: "1. התקנה ברכב של מוצר תעבורה שאינו עומד בדרישות איכות והתאמה אם ההתקנה בוצעה במוסך שאינו מוסך שירות מורשה על-ידי דלק מוטורס."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: "2. שירות שניתן לרכב בניגוד להוראות יצרן הרכב על-ידי מוסך שאינו מוסך שירות מורשה על-ידי דלק מוטורס."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLiText, {
                        children: [
                            " ",
                            "3. אי-עמידה בהוראות יצרן הרכב באשר לטיפולים התקופתיים ברכב, קיומם או מועדם."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLiText, {
                        children: [
                            " ",
                            "4. תיקונים או התקנת חלפים שאינם עומדים בדרישות איכות והתאמה."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "מה אינו מכוסה באחריות המוגבלת לרכב חדש"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUlText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: "נזק או שיתוך שמקורם בשימוש ברכב לא למטרות להן נועד, בתאונות או בשינויי מבנה או דיגום"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: "1. התקנה ברכב של מוצר תעבורה שאינו עומד בדרישות איכות והתאמה אם ההתקנה בוצעה במוסך שאינו מוסך שירות מורשה על-ידי דלק מוטורס."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLiText, {
                        children: [
                            " ",
                            "2. שירות שניתן לרכב בניגוד להוראות יצרן הרכב על-ידי מוסך שאינו מוסך שירות מורשה על-ידי דלק מוטורס."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLiText, {
                        children: [
                            " ",
                            "3. אי-עמידה בהוראות יצרן הרכב באשר לטיפולים התקופתיים ברכב, קיומם או מועדם."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLiText, {
                        children: [
                            " ",
                            "4. תיקונים או התקנת חלפים שאינם עומדים בדרישות איכות והתאמה."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: 'נזק או שיתוך ("קורוזיה") במשטחים, שמקורם בהשפעות סביבתיות'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUlText, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLiText, {
                    children: [
                        " ",
                        "1. כגון גשם חומצי, חומרים הנישאים באוויר (חומרים כימיים, שרף עצים, לשלשת ציפורים וכד'), פגיעות אבנים, מלח, סיכוני הכביש, ברד, סופה, ברק, הצפה, שיטפון ואירועי כוח עליון אחרים."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "נזק עקב היעדר תחזוקה ואי ביצוע טיפול/ים תקופתי/ים או עקב שימוש בדלק, בנוזלים או בחומרי סיכה בלתי מתאימים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUlText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: "1. כגון גשם חומצי, חומרים הנישאים באוויר (חומרים כימיים, שרף עצים, לשלשת ציפורים וכד'), פגיעות אבנים, מלח, סיכוני הכביש, ברד, סופה, ברק, הצפה, שיטפון ואירועי כוח עליון אחרים."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: "2. היעדר תחזוקה תקינה כפי שמוסבר בספר הנהג."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLiText, {
                        children: [
                            " ",
                            "3. תחזוקה לקויה, שימוש בדלק, שמן, נוזלים או חומרי סיכה בלתי מתאימים כמפורט בספר הנהג."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLiText, {
                        children: [
                            " ",
                            "4. נזק הנובע מביצוע טיפולים על-ידי מי שאינו מוסך שירות מורשה מטעם דלק מוטורס."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLiText, {
                        children: [
                            " ",
                            "5.נזק הנובע מאי ביצוע טיפול/ים תקופתי/ים במועדם (בהתאם להוראות בספר הנהג)."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "בלאי רגיל"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUlText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLiText, {
                        children: [
                            " ",
                            "1. בלאי, שחיקה או בלייה רגילים כגון אבדן צבע, דהייה, עיוות, טשטוש וכד'."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLiText, {
                        children: [
                            " ",
                            "2. שיתוך חיצוני על כל חלק שהוא מלבד לוחות פחי המרכב, אשר מעניקים לרכב מתוצרת מאזדה את עיצובו החיצוני."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "עלויות תחזוקה שוטפת"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUlText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLiText, {
                        children: [
                            " ",
                            '1. עלויות תחזוקה שוטפת כגון ניקוי וליטוש ("פוליש"), סיכה ומילוי או החלפה של שמנים, נוזלים, נוזל קירור וכן להבי מגבים, רצועות הנעה, נתיכים, מסננים, רפידות בלם, רפידות המצמד, מיסב המצמד וטס הלחץ של המצמד, מצתים, נוריות מכל סוג, חריטת דסקיות, צלחות בלמים, כיוון זוויות ציר קדמי וציר אחורי, איזון גלגלים, הצלבות גלגלים וכד\' שהחלפתם נובעת מבלאי ושחיקה רגילים.'
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: '2. שירותי התחזוקה המתוארים בפרק "תחזוקה" או "טיפוח מראה המכונית" של ספר הנהג.'
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "שינוי קריאת האודומטר"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUlText, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                    children: "1. כל תיקון של רכב מתוצרת מאזדה שבוצע בו שינוי של קריאת האודומטר או שבו לא ניתן לקבוע בוודאות את מרחק הנסיעה המצטבר."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "הוצאות נוספות ונזקים תוצאתיים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUlText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLiText, {
                        children: [
                            " ",
                            "1. כל אבדן כלכלי. במסגרת זו נכללים, ללא כל הגבלה שהיא, גם עלויות הפסד השימוש ברכב מתוצרת מאזדה, עלויות גרירה, לינה, שכירת רכב, עלויות נסיעה, אבדן שכר וכל הוצאה או נזק אחרים."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: "2. רכיבים המכוסים באחריות נפרדת • צמיגים."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "האחריות לצמיגים המקוריים המותקנים במכוניות מאזדה ניתנת על-ידי יצרן הצמיגים, ואינה ניתנת על-ידי חברת מאזדה. אם נתגלו פגמים בצמיגים ניתן לפנות לאגף השירות של דלק מוטורס לקבלת סיוע בפנייה ליצרן הצמיגים."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUlText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: '1. חלקי חילוף מקוריים של מאזדה המותקנים על-ידי מוסך שירות מורשה מטעם דלק מוטורס (עיין בנושא "אחריות מוגבלת של מאזדה לחלקי חילוף", להלן במסמך זה).'
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: "2. אחריות לאביזרים המותקנים בישראל (כגון מערכות שמע ואזעקה ומיתקונים) ניתנת על-ידי מרכיב הציוד."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                $position: "right",
                $margin: 40,
                children: "חובות בעל הרכב"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 20,
                children: "תפעול ותחזוקה"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUlText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: "על בעל הרכב מוטלת האחריות לתפעל את הרכב ולטפל בו בהתאם להנחיות המפורטות בספר הנהג. כמו-כן, על בעל הרכב לשמור הוכחות המעידות כי בוצעו כנדרש טיפולי תחזוקה נאותים ובמועד לשמירה על כיסוי האחריות."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: "ביצוע הטיפולים התקופתיים יאושר בחוברת זו בחותמת ובחתימת מוסך השירות המורשה. על בעל הרכב לשמור את כל הקבלות ולהציג אותן במקרה בו יתעוררו שאלות ביחס לטיפולי תכנית התחזוקה."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: 'בעל רכב שקיבל שירות במוסך שאינו מוסך שירות מורשה מטעם דלק מוטורס, חייב להציג לדלק מוטורס, באם תבקש זאת, בהתעורר מחלוקת באשר לתוקפה של האחריות לרכב, חשבוניות ערוכות בהתאם לנדרש על פי תקנות רישוי שירותים ומקצועות בענף הרכב (סירוב לתת שירות), התשע"ז – 2017 , לסעיפים 16 (א) ו - 16 (ב) לצו הפיקוח על מצרכים ושירותים (ייצור מוצרי תעבורה והסחר בהם), התשמ"ג - 1983, אשר נתן לו מוסך כאמור בגין השירות לרכב. על החשבוניות לכלול פרטים שיאפשרו לדלק מוטורס לבחון באם מוצרי התעבורה נשוא החשבוניות עומדים בדרישות איכות והתאמה שקבע יצרן הרכב.'
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "שירות המוענק במסגרת האחריות לרכב יינתן רק במוסך שירות מורשה מטעם חברת דלק מוטורס."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: 'אם הרכב מופעל בתנאי נסיעה קשים, על בעל הרכב לפעול בהתאם לדרישות התחזוקה הנוספות המפורטות בספר הנהג ("תנאי נסיעה קשים" משמעותם פעולה באזורים מאובקים מאוד, בטמפרטורות סביבה נמוכות או במשטר נסיעה הכולל נסיעות קצרות רבות בהן המנוע אינו מצליח להגיע לטמפרטורת העבודה הרגילה שלו). מומלץ לבצע את כל טיפולי תוכנית התחזוקה והתיקונים הנדרשים במוסך שירות מורשה מטעם דלק מוטורס.'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "קבלת שירות במסגרת האחריות"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "לשם קבלת שירות במסגרת האחריות יש לפנות עם הרכב — בשעות העבודה המקובלות — למוסך שירות מורשה מטעם דלק מוטורס ולהציג את חוברת האחריות. כל מוסך שירות מורשה מטעם דלק מוטורס יבצע את השירות במסגרת האחריות בכפוף לתנאיה."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "תנאים אחרים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUlText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: "כל האחריויות מכללא מוגבלות בהתאמה למשך התוקף של אחריות זו."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: 'אחריות היצרן מחליפה ומבטלת את כל שאר האחריויות המפורשות (למעט אלה המוגדרות בנפרד בחוברת "מידע לגבי אחריות ורישום טיפולים") שניתנו על-ידי מאזדה, מפיץ מאזדה או סוכן מאזדה ממנו נרכש הרכב. אף מפיץ, סוכן או עובד שלהם אינו רשאי להרחיב או להגדיל אחריות זו. מאזדה ו/או דלק מוטורס לא ישאו בחבות כלשהי בגין נזק נלווה, מיוחד, תוצאתי או פיצויי עונשין וכן לא תחול כל חבות בגין שירות כלשהו שלא הוענק במפורש במסגרת אחריות זו.'
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: "התנאים של כתב אחריות זה אינם פוגעים בזכויות על-פי דין של אנשים שרכשו רכב מתוצרת מאזדה."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "אחריות מוגבלת לפגיעות חירור עקב שיתוך חודר"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUlText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: "כל האחריויות מכללא מוגבלות בהתאמה למשך התוקף של אחריות זו."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                        children: "חברת מאזדה אחראית לכך כי הצבע ולוחות הפח של המרכב ברכב המאזדה החדש שלך — למעט משטחי הגחון וכן (עבור רכב מסחרי) המשטחים הפנימיים של ארגז נשיאת המטען — יהיו חופשיים מפגמים שמקורם בחומר לקוי או בעבודה לקויה, בכפוף לתנאים שלהלן. מוסך שירות מורשה מטעם דלק מוטורס יתקן — ללא חיוב — נזקי צבע ו/או פגיעות שיתוך במשטחים אשר נגרמו עקב חומר לקוי, והופיעו בתנאי שימוש רגילים."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                $position: "right",
                $margin: 40,
                children: "אחריות מוגבלת לצבע ולפגיעות שיתוך במשטחים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "חברת מאזדה אחראית לכך כי הצבע ולוחות הפח של המרכב ברכב המאזדה החדש שלך — למעט משטחי הגחון וכן (עבור רכב מסחרי) המשטחים הפנימיים של ארגז נשיאת המטען — יהיו חופשיים מפגמים שמקורם בחומר לקוי או בעבודה לקויה, בכפוף לתנאים שלהלן. מוסך שירות מורשה מטעם דלק מוטורס יתקן — ללא חיוב — נזקי צבע ו/או פגיעות שיתוך במשטחים אשר נגרמו עקב חומר לקוי, והופיעו בתנאי שימוש רגילים."
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                        $margin: 20,
                        children: "ישימות האחריות המוגבלת לצבע ולפגיעות שיתוך במשטחים"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledUlText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                                children: "האחריות מתייחסת לרכב מתוצרת מאזדה שנרשם ומופעל בישראל."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiText, {
                                children: "במהלך תקופת האחריות ניתן להעבירה לבעלים הבאים של הרכב."
                            })
                        ]
                    })
                ]
            }),
            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                        $margin: 20,
                        children: "ישימות האחריות המוגבלת לצבע ולפגיעות שיתוך במשטחים"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledUl */.hc, {
                        $padding: 25,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                $margin: 20,
                                children: "האחריות מתייחסת לרכב מתוצרת מאזדה שנרשם ומופעל בישראל."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                $margin: 20,
                                children: "במהלך תקופת האחריות ניתן להעבירה לבעלים הבאים של הרכב."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "תקופת האחריות"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "היא 36 חודשים ללא הגבלת מרחק נסיעה מצטבר, החל מן היום בו נמסר הרכב החדש לבעליו."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "סוגי הרכב מתוצרת מאזדה להם מוענק כיסוי במסגרת אחריות זו — רכב פרטי ורכב מסחרי."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "האחריות מוגבלת לצבע ולפגיעות שיתוך במשטחים ואינה מכסה את אחד או יותר מאלה"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledUl */.hc, {
                $padding: 20,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: "כל נזק לצבע ו/או פגיעת שיתוך במשטח של רכב מתוצרת מאזדה אשר מקורם בחומרים תעשיתיים הנישאים באוויר, בתאונה, בנזק מפגיעה חיצונית, בפגיעות אבנים, בשימוש ברכב שלא למטרות להן נועד ובביצוע שינויים ברכב."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: "השפעות סביבתיות, כגון גשם חומצי, חומרים הנישאים באוויר (כדוגמת חומרים כימיים, שרף עצים, לשלשת ציפורים וכד')."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: "כל נזק לצבע ו/או פגיעה במשטח אשר מקורם בפגיעות אופייניות של חול, ברד, הצפה, שיטפון, אבנים וכוח עליון אחר."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: "כל נזק לצבע ו/או פגיעת שיתוך במשטח של רכב מתוצרת מאזדה אשר נגרמו לא כתוצאה מחומר לקוי או עבודה לקויה אלא עקב אי הענקת טיפול לרכב בהתאם להנחיות המפורטות בסעיף 5 להלן ולהנחיות המפורטות בספר הנהג המסופק עם הרכב."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: 'כל שיתוך חיצוני בחלק של רכב מתוצרת מאזדה שאינו לוח פח של המרכב. למען הסר ספק, הביטוי "לוח פח של המרכב" אינו כולל במפורש את כל הרכיבים המהווים חלק ממערכת הפליטה של רכב מתוצרת מאזדה.'
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: "כל נזק לצבע ו/או פגיעת שיתוך חיצונית בחלק(ים) של רכב מתוצרת מאזדה אשר תוקנו לא בהתאם להנחיות המפורטות במפרטי מאזדה המופיעים בספרות הטכנית הישימה של מאזדה ו/או תוך שימוש בחלקים שאינם עומדים בדרישות איכות והתאמה."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "חובות בעל הרכב"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledUl */.hc, {
                $padding: 20,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: 'על בעל הרכב לטפל במכונית המאזדה כמפורט בנושא "טיפוח מראה המכונית" בספר הנהג.'
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: 'על בעל הרכב מוטלת החובה לשמור הוכחות המעידות כי בוצעו טיפולי תחזוקה תקינים ובמועד במכונית המאזדה שלו. ביצוע הטיפולים יאושר בחוברת האחריות ורישום הטיפולים בחותמת ובחתימת מוסך השירות המורשה מטעם דלק מוטורס בו בוצעו הטיפולים ו/או על בעל הרכב לשמור את החשבונית כאמור בסעיף "תפעול ותחזוקה", בנושא "קבלת שירות במסגרת האחריות" לעיל.'
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: 'על בעל הרכב לתקן ללא דיחוי ועל חשבונו כל פגיעה בצבע, חלודה, שיתוך ("קורוזיה") או נזק למיגון שמקורם בהזנחה (התחזוקה השוטפת הינה בתחום אחריות בעל הרכב) או בגורמים חיצוניים שנתגלו במהלך ביקורת.'
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: 'על בעל הרכב להודיע מיד לדלק מוטורס (או מוסך מורשה מטעמה) אם אלו פגיעות בצבע ו/או חלודה ו/או שיתוך ("קורוזיה") בחלק(י) מרכב של מכונית המאזדה שלו.'
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "קבלת שירות במסגרת האחריות"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "לשם קבלת שירות במסגרת האחריות יש לפנות עם הרכב — בשעות העבודה המקובלות — למוסך שירות מורשה מטעם דלק מוטורס ולהציג את חוברת האחריות. כל מוסך שירות מורשה מטעם דלק מוטורס יבצע את השירות במסגרת האחריות ובכפוף לתנאי האחריות."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "אחריות מוגבלת"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: 'החבות של מאזדה במסגרת כתב אחריות זה מוגבלת אך ורק לתיקון של נזקי צבע ו/או שיתוך ("קורוזיה") במשטחים שמקורם בחומר לקוי או בעבודה לקויה. התיקון יבוצע במוסך שירות מורשה מטעם דלק מוטורס. למען הסר כל ספק, אחריות זו אינה כוללת במפורש כל הוצאה ישירה או עקיפה הקשורה להבאת הרכב למוסך השירות וכן אינה כוללת במפורש תשלום בגין אבדן השימוש ברכב המאזדה במהלך ביצוע התיקונים במסגרת האחריות.'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "תנאים אחרים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: 'נושא "תנאים אחרים" מפרק א\' לעיל ישים גם לאחריות זו.'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                $position: "right",
                $margin: 40,
                children: "אחריות מוגבלת לפגיעות חירור עקב שיתוך חודר"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "חברת מאזדה אחראית לכך כי לוחות הפח של המרכב ברכב המאזדה החדש — למעט ארגז נשיאת המטען (עבור רכב מסחרי) — יהיו חופשיים מפגמים שמקורם בחומר לקוי או בעבודה לקויה שיגרמו לחירור עובר (חלודה חודרת) מן הפנים כלפי חוץ, בכפוף לתנאים שלהלן."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "מוסך שירות מורשה מטעם דלק מוטורס יתקן או יחליף — ללא חיוב — כל לוח פח של המרכב אשר נפגע מחירור עקב פגמים שמקורם בחומר לקוי או בעבודה לקויה, ושנתגלו בתנאי שימוש רגילים."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: isDesktop ? 40 : 20,
                children: "ישימות האחריות המוגבלת לפגיעות חירור עקב שיתוך חודר"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: 'אחריות זו מתייחסת לרכב מתוצרת מאזדה שנרשם ומופעל בישראל. במהלך תקופת האחריות ניתן להעבירה לבעלים הבאים של הרכב. אם רכשת רכב מאזדה משומש, שלח את שובר "הודעה על רכישת רכב משומש" (בסוף חוברת "מידע לגבי אחריות ורישום טיפולים") אל אגף השירות של דלק מוטורס.'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "תקופת האחריות"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "תקופת האחריות היא 72 חודשים (ללא הגבלת מרחק נסיעה מצטבר) החל מן היום בו נמסר הרכב החדש לבעליו."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody2 */.ZN, {
                $fontSize: isDesktop ? 16 : 18,
                $margin: !isDesktop && 20,
                children: "סוגי הרכב מתוצרת מאזדה להם מוענק כיסוי במסגרת אחריות זו — רכב פרטי ורכב מסחרי."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody2 */.ZN, {
                $fontSize: isDesktop ? 16 : 18,
                $margin: !isDesktop && 20,
                children: "האחריות מוגבלת לפגיעות חירור עקב שיתוך חודר ואינה מכסה את אחד או יותר מאלה"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledUl */.hc, {
                $padding: 20,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: "כל חירור עקב שיתוך אשר מקורו בחומרים תעשייתיים הנישאים באוויר, בתאונה, בנזק מפגיעה חיצונית, בפגיעות אבנים, בשימוש ברכב שלא למטרות להן נועד ובביצוע שינויים ברכב."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: "כל חירור עקב שיתוך אשר מקורו בפגיעות אופייניות של חול, ברד, הצפה, שיטפון, אבנים וכוח עליון אחר."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: "כל חירור עקב שיתוך אשר נגרם לא כתוצאה מחומר לקוי או עבודה לקויה אלא עקב אי הענקת טיפול לרכב מאזדה בהתאם להנחיות המפורטות בסעיף 5 להלן ולהנחיות המפורטות בספר הנהג המסופק עם הרכב."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: 'כל חירור עקב שיתוך של חלק של רכב מתוצרת מאזדה שאינו לוח פח של המרכב. למען הסר ספק, הביטוי "לוח פח של המרכב" אינו כולל במפורש את כל הרכיבים המהווים חלק ממערכת הפליטה של רכב מתוצרת מאזדה.'
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: "כל חירור עקב שיתוך בחלק(ים) של רכב מתוצרת מאזדה אשר תוקנו לא בהתאם להנחיות המפורטות במפרטי מאזדה המופיעים בספרות הטכנית הישימה של מאזדה ו/או תוך שימוש בחלקים שאינם חלקים מקוריים של מאזדה ו/או אשר תוקנו בידי גורם שאינו מוסך שירות מורשה מטעם דלק מוטורס."
                    })
                ]
            }),
            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                        children: "חובות בעל הרכב"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                        children: 'על בעל הרכב לטפל ברכב המאזדה כמפורט בנושא "טיפוח מראה המכונית" בספר הנהג.'
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledUl */.hc, {
                        $padding: 20,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                $margin: 20,
                                children: "על בעל הרכב לבצע במוסך שירות המורשה מטעם דלק מוטורס, על חשבונו, ביקורת של המרכב במסגרת ביצוע טיפול תחזוקה שנתי (12 חודשים)."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                $margin: 20,
                                children: 'על בעל הרכב מוטלת החובה לשמור הוכחות המעידות כי בוצעו טיפולי תחזוקה וביקורת מרכב תקינים ובמועד ברכב המאזדה שלו. ביצוע הטיפולים יאושר בחוברת "מידע לגבי אחריות ורישום טיפולים" בחותמת ובחתימת מוסך השירות המורשה מטעם דלק מוטורס.'
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                $margin: 20,
                                children: 'על בעל הרכב לתקן ללא דיחוי ועל חשבונו כל פגיעת שיתוך ("קורוזיה") במרכב וכל נזק למיגון שמקורם באי-ביצוע תחזוקה או בגורמים חיצוניים שנתגלו במהלך הביקורת.'
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                                $margin: 20,
                                children: "על בעל הרכב להודיע בהקדם האפשרי למוסך מורשה מטעם דלק מוטורס אם גילה חירור בלוח פח של מרכב רכב המאזדה שלו."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                        children: "קבלת שירות במסגרת האחריות"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                        children: "לשם קבלת שירות במסגרת האחריות יש לפנות עם הרכב — בשעות העבודה המקובלות — למוסך שירות מורשה מטעם דלק מוטורס ולהציג את חוברת האחריות."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                        children: "אחריות מוגבלת"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                        children: "החבות של מאזדה במסגרת כתב אחריות זה מוגבלת אך ורק לתיקון או להחלפה של חלקים שנתגלו בהם פגמים שמקורם בחומר לקוי או בעבודה לקויה. התיקון יבוצע במוסך שירות מורשה מטעם דלק מוטורס. למען הסר כל ספק, אחריות זו אינה כוללת במפורש כל הוצאה ישירה או עקיפה הקשורה להבאת הרכב למוסך השירות וכן אינה כוללת במפורש תשלום בגין אבדן השימוש ברכב המאזדה במהלך ביצוע התיקונים במסגרת האחריות."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                        children: "תנאים אחרים"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                        children: 'נושא "תנאים אחרים" מעמוד 2 לעיל ישים גם לאחריות זו.'
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                $position: "right",
                $margin: 40,
                children: "אחריות מוגבלת לחלפים מקוריים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 20,
                children: "ציוד עזר, חלקי חילוף, שינויים טכניים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: 'אין אנו נוטלים על עצמנו אחריות כלשהי עבור חלקי חילוף, אביזרים, ציוד עזר או מכללים שלא אושרו על-ידי מאזדה ו/או שלא נרכשו כנגד חשבונית מס מקורית של חברת דלק מוטורס וכן אנו מסירים מעצמנו אחריות כלשהי עבור שינויים טכניים בלתי-מאושרים שבוצעו ברכב. חברת מאזדה אינה מסוגלת לבחון ולהעריך כנדרש את הבטיחות, ההתאמה והאמינות של מוצרי תעבורה זרים כנ"ל ולכן לא תוענק להם אחריות כלשהי.'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "ניתן לרכוש חלקי חילוף מקוריים של מאזדה, אביזרים מקוריים של מאזדה ומוצרים אחרים המאושרים על-ידי מאזדה מחברת דלק מוטורס או מנציגים מאושרים מטעמה."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                $margin: 40,
                children: "לפני רכישה של חלקים או אביזרים וכן לפני ביצוע שינויים טכניים כלשהם מומלץ לפנות לייעוץ אל מוסך שירות מורשה מטעם דלק מוטורס. חברת מאזדה אחראית לכך כי חלקי-חילוף מקוריים של מאזדה יהיו חופשיים מפגמים שמקורם בחומר לקוי או בעבודה לקויה, בכפוף לתנאים שלהלן. אחריות זו מכסה חלקי חילוף מקוריים חדשים, מתוקנים ומשופצים של מאזדה שנמכרו והותקנו במוסך שירות מורשה מטעם דלק מוטורס. מוסך שירות מורשה מטעם דלק מוטורס יתקן או יחליף ללא חיוב כל חלק חילוף לשם תיקון של פגם כלשהו המכוסה באחריות."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "ישימות האחריות המוגבלת לחלפים מקוריים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "האחריות המוגבלת לחלקים מקוריים ישימה לחלקי חילוף מקוריים של מאזדה שנרכשו בדלק מוטורס כנגד חשבונית מקורית ואשר הותקנו ברכב כלשהו מתוצרת מאזדה שנרשם ומופעל בישראל. במהלך תקופת האחריות ניתן להעבירה לבעלים החדשים של הרכב."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "חלקי חילוף"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "חלקי חילוף מכוסים למשך 12 החודשים הראשונים ללא הגבלת מרחק נסיעה, החל מן היום בו הותקנו במוסך שירות מורשה מטעם דלק מוטורס."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "האחריות המוגבלת לחלקים מקוריים אינה מכסה"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledUl */.hc, {
                $padding: 20,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: "חלקי חילוף מקורייים של מאזדה שהותקנו במסגרת האחריויות הישימות לרכב המאזדה שלך."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: 'נזק או שיתוך ("קורוזיה") שמקורם בתאונות, בשימוש ברכב לא למטרות להן נועד או בשינויי מבנה או דיגום.'
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: "נזק או שיתוך במשטחים שמקורם בהשפעות סביבתיות כגון גשם חומצי, חומרים הנישאים באוויר (חומרים כימיים, שרף עצים, לשלשת צפורים וכד'), פגיעות אבנים, מלח, סיכוני הכביש, ברד, סופה, ברק, הצפה, שיטפון ואירועי כוח עליון אחרים."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: "בלאי, שחיקה או בלייה עקב שימוש רגיל, אבדן צבע, דהייה, עיוות, טשטוש וכד'."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: "חלקי חילוף מקוריים של מאזדה שהותקנו ברכב מתוצרת מאזדה שבוצע בו שינוי של קריאת האודומטר או שבו לא ניתן לקבוע בוודאות את מרחק הנסיעה המצטבר."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: "חלקי חילוף מקוריים של מאזדה שנעשה בהם שימוש ביישומים שלא נועדו להם."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLi */.EF, {
                        $margin: 20,
                        children: "כל חלק חילוף מקורי של מאזדה שאין הוכחה לגבי מועד התקנתו."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "קבלת שירות במסגרת האחריות"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "לשם קבלת שירות במסגרת האחריות על בעל הרכב לפנות עם המכונית - בשעות העבודה המקובלות - למוסך שירות מורשה מטעם חברת דלק מוטורס ולהציג את חוברת האחריות. כל מוסך שירות מורשה מטעם חברת דלק מוטורס יבצע את השירות במסגרת האחריות."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "אחריות מוגבלת"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: "החבות של מאזדה במסגרת כתב אחריות זה מוגבלת אך ורק לתיקון או החלפה של חלקים שנתגלו בהם נזקים שמקורם בחומר לקוי או בעבודה לקויה. התיקון יבוצע במוסך שירות מורשה מטעם דלק מוטורס. למען הסר כל ספק, אחריות זו אינה כוללת במפורש כל הוצאה ישירה או עקיפה הקשורה להבאת הרכב למוסך השירות וכן אינה כוללת במפורש תשלום בגין אבדן השימוש ברכב המאזדה במהלך ביצוע התיקונים במסגרת האחריות."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeaderSubtitle, {
                $margin: 40,
                children: "תנאים אחרים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                children: 'נושא "תנאים אחרים" מפרק א\' לעיל ישים גם לאחריות זו.'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                $position: "right",
                $margin: 40,
                children: "מוקד שירות לקוחות"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledLink */.Fg, {
                href: "tel:*2880",
                $margin: 10,
                $color: "#4C607E",
                style: {
                    unicodeBidi: "plaintext"
                },
                children: "*2880"
            })
        ]
    });
};
/* harmony default export */ var warranty_WarrantyBody = (WarrantyBody);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./reusable/wrappers/CenterText.tsx
var CenterText = __webpack_require__(86040);
;// CONCATENATED MODULE: ./components/pages/warranty/WarrantyHeader.tsx

function WarrantyHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  ",
        " {\n    text-align: right;\n  }\n"
    ]);
    WarrantyHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WarrantyHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: right;\n  margin-top: 20px;\n"
    ]);
    WarrantyHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WarrantyHeader_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 0.5px solid ",
        ";\n  margin-top: 40px;\n"
    ]);
    WarrantyHeader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WarrantyHeader_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  margin-top: 20px;\n"
    ]);
    WarrantyHeader_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 60px;\n  height: 40px;\n  border: 2px solid black;\n  &:hover {\n    border: 2px solid black;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var WarrantyHeader_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "WarrantyHeader__StyledWrapper",
    componentId: "sc-d166a7a2-0"
})(WarrantyHeader_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledBodyRed = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "WarrantyHeader__StyledBodyRed",
    componentId: "sc-d166a7a2-1"
})(WarrantyHeader_templateObject1(), function(p) {
    return p.theme.colors.mazdaRed;
});
var StyledLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "WarrantyHeader__StyledLine",
    componentId: "sc-d166a7a2-2"
})(WarrantyHeader_templateObject2(), function(p) {
    return p.theme.colors.darkGrey;
});
var StyledButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "WarrantyHeader__StyledButtonWrapper",
    componentId: "sc-d166a7a2-3"
})(WarrantyHeader_templateObject3());
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    variant: "outlined"
}).withConfig({
    displayName: "WarrantyHeader__StyledButton",
    componentId: "sc-d166a7a2-4"
})(_templateObject4());
var WarrantyHeader = function() {
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WarrantyHeader_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterText/* StyledHeaderH1 */.O, {
                children: "כתב אחריות"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                $margin: 20,
                $fontSize: "20",
                children: "שמחים שהתחדשת במאזדה!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyText/* StyledBody */.vc, {
                $margin: 20,
                children: [
                    "כאן אפשר להתעדכן בתנאים העיקריים של האחריות לרכב חדש.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "פרטי האחריות המלאים יימסרו לך עם קבלת הרכב"
                ]
            }),
            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                    onClick: function() {
                        return window.print();
                    },
                    children: "הדפס"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledHeaderH2 */.x0, {
                $position: "right",
                $margin: 20,
                $fontSize: "20",
                $fontWeight: "300",
                children: "סוגי האחריות המוענקים לרכב מאזדה חדש:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                $position: "right",
                $margin: 20,
                children: "1.אחריות מוגבלת לרכב חדש"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                $position: "right",
                $margin: 20,
                children: "2.אחריות מוגבלת לצבע ולפגיעות שיתוך במשטחים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                $position: "right",
                $margin: 20,
                children: "3.אחריות מוגבלת לפגיעות חלודה חודרת"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyText/* StyledBody */.vc, {
                $position: "right",
                $margin: 20,
                children: "4. אחריות מוגבלת לחלפים מקוריים"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBodyRed, {
                children: [
                    "*חשוב - מסמך זה נועד לידיעה בלבד. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "הנוסח הקובע של האחריות מפורט בחוברת האחריות ורישום הטיפולים."
                ]
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                    onClick: function() {
                        return window.print();
                    },
                    children: "הדפסה"
                })
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLine, {})
        ]
    });
};
/* harmony default export */ var warranty_WarrantyHeader = (WarrantyHeader);

;// CONCATENATED MODULE: ./components/pages/warranty/WarrantyPage.tsx

function WarrantyPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  display: flex;\n  align-items: center;\n  background: ",
        ";\n  padding-bottom: 80px;\n"
    ]);
    WarrantyPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WarrantyPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 40px;\n  max-width: 1400px;\n  padding-right: 150px;\n  padding-left: 150px;\n  ",
        " {\n    padding-right: 20px;\n    padding-left: 20px;\n  }\n"
    ]);
    WarrantyPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var StyledPageDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "WarrantyPage__StyledPageDiv",
    componentId: "sc-e860f84-0"
})(WarrantyPage_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
});
var StyledTextWrapp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "WarrantyPage__StyledTextWrapp",
    componentId: "sc-e860f84-1"
})(WarrantyPage_templateObject1(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var WarrantyPage = function() {
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* StyledPageWrapper */.S0, {
        $padding: "0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPageDiv, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer/* default */.Z, {
                    src: isDesktop ? "/img/Warranty.jpg" : "/img/Warrantymobile.jpg"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                    name: "Warranty"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTextWrapp, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(warranty_WarrantyHeader, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(warranty_WarrantyBody, {})
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var warranty_WarrantyPage = (WarrantyPage);

;// CONCATENATED MODULE: ./src/pages/warranty.tsx



var Warranty = function(param) {
    var seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(warranty_WarrantyPage, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var warranty = (Warranty);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(71007); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);